const HERO_FILES = [
  "Remind.jpeg",
  "Fantastic.jpeg",
  "Cleopatra.jpeg",
  "Arlom.jpeg",
  "Sensation.jpeg",
  "Sublime-2.jpeg",
  "Iron.jpeg",
  "Euridice.jpeg",
  "Radisson.jpeg",
  "Hypnose-2.jpeg",
  "Dream.jpg",
  "Nirvana-1.jpeg",
  "Hypnose.jpeg",
  "Nirvana-2.jpeg",
  "Armonie.jpg",
  "Rebecca.jpeg",
  "Sublime.jpeg",
] as const;

const HERO_WIDTHS = [640, 960, 1280, 1600, 1920, 2560] as const;
export const HERO_SIZES = "100vw";

export function optimizedHeroUrl(src: string, width: number) {
  const url = new URL(src);
  return `${url.origin}/cdn-cgi/image/width=${width},quality=80,format=auto,fit=scale-down${url.pathname}`;
}

// Keep the shuffled order stable so the first image matches the head preload.
export const HERO_SLIDES = HERO_FILES.map((file) => {
  const src = `https://media.lacontessina.com/site/hero/${file}`;
  return {
    src,
    optimizedSrc: optimizedHeroUrl(src, 1920),
    srcSet: HERO_WIDTHS.map((width) => `${optimizedHeroUrl(src, width)} ${width}w`).join(", "),
    collection: file.replace(/\.[^.]+$/, "").replace(/-\d+$/, ""),
  };
});
